import { render, staticRenderFns } from "./supplyModel.vue?vue&type=template&id=413c0164&scoped=true"
import script from "./supplyModel.vue?vue&type=script&lang=js"
export * from "./supplyModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413c0164",
  null
  
)

export default component.exports